/* =========================================================
   Cellfy · BGS 2026 — Cadastro (form)
   - Submit AJAX direto pra RD Station Marketing API (API Key)
   - Mesmo padrão do hero-launch-form.js: sem reload, view de
     sucesso, legal_bases automático, telefone em E.164,
     data-rdstation-form="false" pra evitar conversão duplicada
   - Campo extra: marca_interesse (MCHOSE / PXN) enviado como
     campo customizado no payload da RD
   ========================================================= */
(function () {
  'use strict';

  var RD_API_URL = 'https://api.rd.services/platform/conversions';

  function initForm(section) {
    if (!section || section.dataset.cbgsFormInit === 'true') return;
    section.dataset.cbgsFormInit = 'true';

    var form = section.querySelector('[data-cbgs-form]');
    if (!form) return;

    form.setAttribute('data-rdstation-form', 'false');
    form.classList.add('rd-no-track');

    var formView = section.querySelector('[data-cbgs-view="form"]');
    var successView = section.querySelector('[data-cbgs-view="success"]');
    var errorsBox = section.querySelector('[data-cbgs-form-errors]');
    var cta = section.querySelector('[data-cbgs-cta]');
    var ctaLabel = section.querySelector('[data-cbgs-cta-label]');

    var apiKey = section.dataset.rdApiKey;
    var conversionIdentifier = section.dataset.rdConversionIdentifier || 'bgs-2026-pular-fila';
    var customFieldMarca = section.dataset.rdCustomFieldMarca || 'cf_marca_de_interesse_bgs';
    var rawTags = section.dataset.rdTags || '';
    var tags = rawTags
      .split(',')
      .map(function (t) { return t.trim(); })
      .filter(function (t) { return t.length > 0; });

    function showError(message) {
      if (!errorsBox) return;
      errorsBox.textContent = message;
      errorsBox.hidden = false;
    }

    function clearError() {
      if (!errorsBox) return;
      errorsBox.textContent = '';
      errorsBox.hidden = true;
    }

    function setLoading(isLoading) {
      if (!cta) return;
      cta.disabled = isLoading;
      if (isLoading) {
        cta.classList.add('is-loading');
        if (ctaLabel) {
          cta.dataset.originalLabel = ctaLabel.textContent;
          ctaLabel.textContent = 'Enviando...';
        }
      } else {
        cta.classList.remove('is-loading');
        if (ctaLabel && cta.dataset.originalLabel) {
          ctaLabel.textContent = cta.dataset.originalLabel;
        }
      }
    }

    function showSuccess() {
      if (!formView || !successView) return;
      formView.hidden = true;
      successView.hidden = false;
      var card = section.querySelector('.cbgs-form-card');
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function phoneDigits(value) {
      var digits = (value || '').replace(/\D/g, '').replace(/^0+/, '');
      if ((digits.length === 12 || digits.length === 13) && digits.indexOf('55') === 0) {
        digits = digits.slice(2);
      }
      return digits;
    }

    function isValidPhone(value) {
      var digits = phoneDigits(value);
      return digits.length === 10 || digits.length === 11;
    }

    function normalizePhone(value) {
      var digits = phoneDigits(value);
      if (!digits) return '';
      return '+55' + digits;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearError();

      var name = (form.querySelector('[name="name"]') || {}).value || '';
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      var phone = (form.querySelector('[name="mobile_phone"]') || {}).value || '';
      var marcaInput = form.querySelector('[name="marca_interesse"]:checked');
      var marca = marcaInput ? marcaInput.value : '';

      name = name.trim();
      email = email.trim();
      phone = phone.trim();

      if (!name) {
        showError('Por favor, informe seu nome.');
        return;
      }
      if (!email || !isValidEmail(email)) {
        showError('Por favor, informe um e-mail válido.');
        return;
      }
      if (!isValidPhone(phone)) {
        showError('Por favor, informe um WhatsApp válido com DDD.');
        return;
      }
      if (!marca) {
        showError('Selecione a marca de interesse (MCHOSE ou PXN).');
        return;
      }
      if (!apiKey) {
        showError('Configuração inválida. Contate o suporte.');
        // eslint-disable-next-line no-console
        console.error('[cellfy-bgs-form] RD Station API Key não configurada no customizer.');
        return;
      }

      setLoading(true);

      var payload = {
        event_type: 'CONVERSION',
        event_family: 'CDP',
        payload: {
          conversion_identifier: conversionIdentifier,
          name: name,
          email: email,
          mobile_phone: normalizePhone(phone),
          tags: tags,
          available_for_mailing: true,
          legal_bases: [
            {
              category: 'communications',
              type: 'consent',
              status: 'granted'
            }
          ],
          traffic_source: document.referrer || ''
        }
      };

      payload.payload[customFieldMarca] = marca;

      var endpoint = RD_API_URL + '?api_key=' + encodeURIComponent(apiKey);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.status === 200 || response.status === 201 || response.status === 204) {
            return null;
          }
          return response.json().then(function (data) {
            throw new Error(
              (data && data.errors && JSON.stringify(data.errors)) ||
              'Erro ao enviar (status ' + response.status + ')'
            );
          }).catch(function () {
            throw new Error('Erro ao enviar (status ' + response.status + ')');
          });
        })
        .then(function () {
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({
              event: 'rd_conversion',
              conversion_identifier: conversionIdentifier,
              marca_interesse: marca
            });
          }
          showSuccess();
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.error('[cellfy-bgs-form] Erro RD Station:', err);
          setLoading(false);
          showError('Não foi possível enviar agora. Tente novamente em instantes.');
        });
    }, true);
  }

  function initAll() {
    document.querySelectorAll('.cbgs-form-section').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cbgs-form-section');
    if (section) initForm(section);
  });
})();